import React from 'react';
import { useTheme } from 'styled-components';
import { Client } from '../../../2_domain/client/client';
import toIDString from '../../../lib/util/dateFormatter';
import LXInformationCard from '../../core/components/box/lxInformationCard';

interface ClientInfoViewProps {
  client: Client;
}

const ClientInfoView: React.FC<ClientInfoViewProps> = (props) => {
  const theme = useTheme();

  const left = new Map<string, string>();
  const right = new Map<string, string>();

  left.set(theme.texts.name, props.client.name);

  left.set(theme.texts.dateOfBirth, toIDString(props.client.birthday));
  left.set(theme.texts.gender, props.client.gender);
  left.set(theme.texts.pregnancy, props.client.pregnancy ? 'Y' : 'N');
  if (props.client.pregnancy && props.client.menstrualDate)
    left.set(
      theme.texts.lastMenstrualDate,
      toIDString(props.client.menstrualDate)
    );
  left.set(theme.texts.nationality, props.client.nationality);
  props.client.nationality === 'INDONESIA'
    ? left.set(theme.texts.nik, props.client.idNumber!)
    : left.set(theme.texts.passportNumber, props.client.passportNumber!);

  right.set(theme.texts.phone, props.client.phone);
  right.set(theme.texts.email, props.client.email);
  right.set(theme.texts.memo, props.client.memo);

  return <LXInformationCard left={left} right={right}></LXInformationCard>;
};

export default ClientInfoView;
